export default __webpack_public_path__ + "media/IntroductionModalGraphic.3e63577f34fcef3aefa17732a6d9d6e9.svg";